import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext } from '@philips-internal/oswald-ui-foundation/lib/context';

import { setup as setupAuthentication } from './authentication';
import { setup as setupModules } from './modules';
import { setup as setupTheme } from './theme';

function bootstrap(): Promise<void> {
  applicationContext.setTitle(MessageService.translate('application.name'));

  setupAuthentication();
  setupModules();
  setupTheme();

  return Promise.resolve();
}

export {
  bootstrap,
};
